import { path } from 'ramda'
import React from 'react'

import { TO_GROUP } from '../_constants/assignConstants'
import { useCloneForm, useCloneFormActions } from '../_form/CloneServiceOrderForm'
import GroupsSelect from '../../../../containers/groups/select/GroupsSelect'

const GroupAssign = () => {
  const form = useCloneForm()
  const { handleChange } = useCloneFormActions()

  if (form.assign !== TO_GROUP) return false

  return (
    <GroupsSelect
      selectedLabel={path(['group', 'name'], form)}
      onChange={(_, __, { origin }) => {
        handleChange('group', origin)
      }}
    />
  )
}

export default GroupAssign
